import { type APIConfiguration, Service, useList } from "@api/common";
import type {
  ListParams,
  OrgAccess,
  OrgMember,
  OrgNotificationPreference,
  OrgVoicePreference,
  PopulatedOrgMember,
} from "./types";

export type { OrgMember, PopulatedOrgMember };

export class OrgMemberService extends Service<OrgMember> {
  constructor() {
    super("/org-members");
  }

  async acceptInvite(token: string) {
    return this.post(`${this.basePath}`, { token });
  }

  async updateMember(memberId: string, body: { access: OrgAccess }) {
    return this.put(`${this.basePath}/${memberId}`, body);
  }

  async removeMember(memberId: string) {
    return this.delete(`${this.basePath}/${memberId}`);
  }

  async updateMemberPreferences(
    memberId: string,
    body: { notifications?: OrgNotificationPreference[]; voice?: OrgVoicePreference[] },
  ) {
    return this.put(`${this.basePath}/${memberId}/preferences`, body);
  }
}

export const orgMemberService = new OrgMemberService();

export function useOrgMembers(
  org: string,
  params?: ListParams<OrgMember> & { "access.role"?: any },
  config?: APIConfiguration,
) {
  return useList<PopulatedOrgMember>(
    orgMemberService as any,
    { org, populate: "org user", ...params },
    config,
  );
}
